import React, { useState, useEffect, lazy, Suspense } from 'react';
import RentalForm from './components/RentalForm';
import RequestsList from './components/RequestsList';
import LoginForm from './components/LoginForm';
import MyBookings from './components/MyBookings';
import Profile from './components/Profile';
import OfferPage from './pages/OfferPage';
import SuccessPage from './pages/SuccessPage';
import './App.css';
import './styles/global.css';
  import { 
  IconMap, 
  IconList, 
  IconPlus, 
  IconCalendarEvent, 
  IconUser,
  IconStar  
} from '@tabler/icons-react';
import TariffsPage from './components/TariffsPage';
import MyAds from './components/MyAds';
import BookingForm from './components/BookingForm';
import Header from './components/Header';
import Navigation from './components/Navigation'; 


// ✅ Ленивая загрузка MapView (Яндекс.Карты не грузятся на других страницах)
const MapView = lazy(() => import('./components/MapView'));

const API_URL = process.env.REACT_APP_API_URL || '/api';
function App() {
  // Авторизация
  const [user, setUser] = useState(null);
  const [isAuth, setIsAuth] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);
  
  // UI состояние
  const [activeView, setActiveView] = useState('list');
  const [requestsType, setRequestsType] = useState({});
  const [equipmentModels, setEquipmentModels] = useState({});
  const [requests, setRequests] = useState([]);
  const [citys, setCitys] = useState([]);
  const [selectedEquipment, setSelectedEquipment] = useState('');
  const [selectedRequestType, setSelectedRequestType] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [userRequestsCount, setUserRequestsCount] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCity, setSelectedCity] = useState('Ростов-на-Дону');
  const [selectedRequest, setSelectedRequest] = useState(null); 
  const [selectedEquipmentForBooking, setSelectedEquipmentForBooking] = useState(null);
  const [userSubscription, setUserSubscription] = useState(null);
  


   
  // ✅ ДОБАВЬТЕ ЭТИ ДВЕ СТРОЧКИ
  const [activeSubscription, setActiveSubscription] = useState(null);
  const [activeTariff, setActiveTariff] = useState(null);

  // Проверка авторизации при загрузке + обработка ?view=
  useEffect(() => {
    const token = localStorage.getItem('token');
    const savedUser = localStorage.getItem('user');

    if (token && savedUser) {
      const userData = JSON.parse(savedUser);
      setUser(userData);
      setIsAuth(true);
    }

    // ✅ Обработка ?view=myBookings | list | myAds | tariffs | profile | form
    const params = new URLSearchParams(window.location.search);
    const view = params.get('view');
    const allowedViews = ['map', 'list', 'form', 'myAds', 'myBookings', 'profile', 'tariffs'];
    if (view && allowedViews.includes(view)) {
      if (token && savedUser) {
        setActiveView(view);
      } else {
        setPendingAction(view);
        setShowAuthModal(true);
      }
      window.history.replaceState({}, '', window.location.pathname);
    }

    setLoading(false);
  }, [])

   // ✅ Слушатель обновления данных пользователя
  useEffect(() => {
    const handleUserDataUpdated = () => {
      const savedUser = localStorage.getItem('user');
      if (savedUser) {
        setUser(JSON.parse(savedUser));
        setIsAuth(true);
      }
      
      const token = localStorage.getItem('token');
      if (!token) return;
      
      // ✅ Обновляем userSubscription (для шапки)
      fetch(`${API_URL}/my-subscription`, {
        headers: { 'Authorization': `Bearer ${token}` }
      })
      .then(r => r.ok ? r.json() : null)
      .then(data => {
        if (data && data.is_active) {
          setUserSubscription(data);
          setActiveSubscription(data);
          setActiveTariff(data.tariff);
        } else {
          setUserSubscription(null);
          setActiveSubscription(null);
          setActiveTariff(null);
        }
      })
      .catch(() => {});
    };
    
    window.addEventListener('userDataUpdated', handleUserDataUpdated);
    return () => window.removeEventListener('userDataUpdated', handleUserDataUpdated);
  }, [user]);

    // ✅ Слушатель перехода на тарифы
  useEffect(() => {
    const handleGoToTariffs = () => {
      setActiveView('tariffs');
    };
    
    window.addEventListener('goToTariffs', handleGoToTariffs);
    return () => window.removeEventListener('goToTariffs', handleGoToTariffs);
  }, []);

  
useEffect(() => {
    if (user && user.id) {
        const fetchUserSubscription = async () => {
            try {
                const response = await fetch('/api/my-subscription', {
                    headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
                });
                if (response.ok) {
                    const data = await response.json();
                    setUserSubscription(data.is_active ? data : null);
                }
            } catch (error) {
                console.error('Ошибка загрузки подписки:', error);
            }
        };
        fetchUserSubscription();
    }
}, [user]);
  // Загрузка городов
  useEffect(() => {
    const loadCitys = async () => {
      try {
        const response = await fetch(`${API_URL}/citys`);
        if (!response.ok) throw new Error('Ошибка при загрузке городов');
        const data = await response.json();
        setCitys(data);
      } catch (error) {
        console.error('Ошибка при загрузке городов:', error);
      }
    };
    loadCitys();
  }, []);

const handleTariffsClick = () => {
    if (!isAuth) {
        setPendingAction('tariffs');
        setShowAuthModal(true);
        return;
    }
    // Всегда показываем тарифы, даже если уже исполнитель
    setActiveView('tariffs');
};

const handleMyAdsClick = () => {
    if (!isAuth) {
        setPendingAction('myAds');
        setShowAuthModal(true);
        return;
    }
    setActiveView('myAds');
};
  // Загрузка типов заявок и моделей оборудования
  useEffect(() => {
    const loadMappings = async () => {
      try {
        const [requestsTypesResponse, equipmentResponse] = await Promise.all([
          fetch(`${API_URL}/requeststype`),
          fetch(`${API_URL}/equipment`),
        ]);

        if (!requestsTypesResponse.ok || !equipmentResponse.ok) {
          throw new Error('Ошибка при загрузке данных');
        }

        const [requestsTypesData, equipmentData] = await Promise.all([
          requestsTypesResponse.json(),
          equipmentResponse.json(),
        ]);

        const requestsTypesMap = {};
        requestsTypesData.forEach((type) => (requestsTypesMap[type.id] = type.type_name));

        const equipmentModelsMap = {};
        equipmentData.forEach((equipment) => (equipmentModelsMap[equipment.id] = equipment.model));

        setRequestsType(requestsTypesMap);
        setEquipmentModels(equipmentModelsMap);
      } catch (error) {
        console.error('Ошибка при загрузке маппинга:', error);
      }
    };
    loadMappings();
  }, []);

  // Загрузка заявок (публичная, без авторизации)
  const fetchRequests = async () => {
    try {
      const response = await fetch(`${API_URL}/requests`);
      if (!response.ok) throw new Error('Ошибка при загрузке заявок');
      const data = await response.json();
      setRequests(data);
    } catch (error) {
      console.error('Ошибка при загрузке заявок:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // Загрузка заявок при монтировании
  useEffect(() => {
    fetchRequests();
  }, []);

  // Загрузка подписки и лимитов (только для авторизованных)
useEffect(() => {
    if (user && user.id) {
        const fetchSubscription = async () => {
            try {
                const response = await fetch(`${API_URL}/subscriptions?user_id=${user.id}`);
                
                if (response.status === 404) {
                    // Нет активной подписки
                    setActiveSubscription(null);
                    setActiveTariff(null);
                    return;
                }
                
                if (!response.ok) {
                    throw new Error(`HTTP ${response.status}`);
                }
                
                const data = await response.json();
                if (data.tariff) {
                    setActiveSubscription(data);
                    setActiveTariff(data.tariff);
                }
            } catch (error) {
                console.error('Ошибка при загрузке подписки:', error);
                setActiveSubscription(null);
                setActiveTariff(null);
            }
        };
        
        fetchSubscription();
        
        // Обновляем счётчик заявок пользователя
        const userRequests = requests.filter(request => request.user_id === user.id);
        setUserRequestsCount(userRequests.length);
    }
}, [user, requests]);

  // Обработчики фильтров
  const handleEquipmentChange = (e) => setSelectedEquipment(e.target.value);
  const handleRequestTypeChange = (e) => setSelectedRequestType(e.target.value);
  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    const selectedCityItem = citys.find((city) => city.name === query);
    if (selectedCityItem) setSelectedCity(selectedCityItem.name);
  };

  // Проверка лимита объявлений
  const checkRequestLimit = () => {
    if (activeTariff) {
      const maxAds = activeTariff.max_ads || 0;
      if (userRequestsCount >= maxAds) {
        alert(`Превышен лимит на создание объявлений (${maxAds}). Пожалуйста, подключите другой тариф.`);
        return false;
      }
    }
    return true;
  };

  // Создание заявки (только для авторизованных)
  const handleFormSubmit = async (formData) => {
    // 1. Проверка авторизации
    if (!isAuth) {
        setPendingAction('createRequest');
        setShowAuthModal(true);
        return;
    }
    
    // 2. Проверка подписки для создания объявления (type_id === 2 — "Сдаю технику")
    if (formData.type_id === 2) {
        const hasSubscription = await checkUserSubscription();
        if (!hasSubscription) {
            alert('Для создания объявления нужна активная подписка. Перейдите в раздел "Тарифы".');
            setActiveView('tariffs');
            return;
        }
    }
    
    // 3. Проверка лимита объявлений
    if (!checkRequestLimit()) return;
    
    // Проверка для исполнителей
    if (user?.role === 'contractor' && !checkRequestLimit()) {
        return; // checkRequestLimit уже показывает alert
    }

    try {
        const response = await fetch(`${API_URL}/requests`, {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify({ ...formData, user_id: user.id }),
        });

        if (response.ok) {
            alert('Заявка успешно создана!');
            setActiveView('map');
            fetchRequests();
        } else {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Ошибка при создании заявки');
        }
    } catch (error) {
        console.error('Ошибка при создании заявки:', error);
        alert(error.message);
    }
};

const checkUserSubscription = async () => {
    try {
        const token = localStorage.getItem('token');
        if (!token) return false;
        
        const response = await fetch(`${API_URL}/my-subscription`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        
        if (!response.ok) return false;
        
        const data = await response.json();
        return data.is_active === true;
    } catch (error) {
        console.error('Ошибка проверки подписки:', error);
        return false;
    }
};

  // Навигация
  const handleRentalRequestClick = () => {
    if (!isAuth) {
      setPendingAction('createRequest');
      setShowAuthModal(true);
      return;
    }
    setActiveView('form');
  };

  const handleViewMapClick = async () => {
    setActiveView('map');
    await fetchRequests();
  };

  const handleViewRequestsClick = async () => {
    setActiveView('list');
    await fetchRequests();
  };

  const handleMyBookingsClick = () => {
    if (!isAuth) {
      setPendingAction('myBookings');
      setShowAuthModal(true);
      return;
    }
    setActiveView('myBookings');
  };

  const handleProfileClick = () => {
    if (!isAuth) {
      setPendingAction('profile');
      setShowAuthModal(true);
      return;
    }
    setActiveView('profile');
  };

  const handleLogin = (userData) => {
    setUser(userData);
    setIsAuth(true);
    setShowAuthModal(false);
    // После входа выполняем отложенное действие
    if (pendingAction === 'createRequest') setActiveView('form');
    if (pendingAction === 'form') setActiveView('form');
    if (pendingAction === 'myBookings') setActiveView('myBookings');
    if (pendingAction === 'profile') setActiveView('profile');
    if (pendingAction === 'tariffs') setActiveView('tariffs');   
    if (pendingAction === 'myAds') setActiveView('myAds');
    if (pendingAction === 'list') setActiveView('list');
    if (pendingAction === 'map') setActiveView('map');      
    setPendingAction(null);
    fetchRequests();
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
    setIsAuth(false);
    setActiveView('map');
  };

  // Страница оферты
  if (window.location.pathname === '/offer') {
    return <OfferPage />;
  }
// Страница успешной оплаты
if (window.location.pathname === '/success') {
    return <SuccessPage />;
}

  if (loading) return <div>Загрузка...</div>;

  return (
    <div className="App min-h-screen bg-slate-50">
      {/* Шапка */}
      <Header 
        activeView={activeView}
        user={user}
        userSubscription={userSubscription}
        isAuth={isAuth}
        onTariffs={handleTariffsClick}
        onLogout={handleLogout}
        onLogin={() => setShowAuthModal(true)}
        onMapClick={handleViewMapClick}
      />

      {/* Навигация */}
      <Navigation 
        user={user}
        activeView={activeView}
        onMapClick={handleViewMapClick}
        onListClick={handleViewRequestsClick}
        onCreateClick={handleRentalRequestClick}
        onTariffsClick={handleTariffsClick}
        onMyAdsClick={handleMyAdsClick}
        onBookingsClick={handleMyBookingsClick}
        onProfileClick={handleProfileClick}
      />{/* Контент */}
      <div className="content-container" style={{ padding: '20px' }}>
        {activeView === 'map' && (
          <Suspense fallback={<div style={{ padding: '60px', textAlign: 'center', color: '#666' }}>🗺️ Загрузка карты...</div>}>
            <MapView
              requests={requests}
              requestsType={requestsType}
              equipmentModels={equipmentModels}
              user={user}
              isAuth={isAuth}
              userSubscription={userSubscription}
              onAuthRequired={() => setShowAuthModal(true)}
              onShowBooking={(request) => setSelectedRequest(request)}
            />
          </Suspense>
        )}

        {activeView === 'list' && (
          <RequestsList
            requests={requests}
            setRequests={setRequests}
            requestsType={requestsType}
            equipmentModels={equipmentModels}
            userTelegramId={user?.id}
            isAuth={isAuth}
            onAuthRequired={() => setShowAuthModal(true)}
            onShowBooking={(request) => setSelectedRequest(request)}
            user={user}
          />
        )}

       {activeView === 'tariffs' && (
       <TariffsPage 
        user={user} 
        activeSubscription={activeSubscription}
        activeTariff={activeTariff}
            />
        )}

        {activeView === 'myAds' && isAuth && (
             <MyAds 
        userId={user?.id} 
        equipmentModels={equipmentModels}
        requestsType={requestsType}
    />
        )}


        {activeView === 'form' && isAuth && (
        <RentalForm
          requestsType={requestsType}
          equipmentModels={equipmentModels}
          onSubmit={handleFormSubmit}
          onCancel={handleViewMapClick}
          userId={user?.id}
          hasSubscription={userSubscription?.is_active || false}
          />
        )}

        {activeView === 'myBookings' && isAuth && (
          <MyBookings userId={user?.id} equipmentModels={equipmentModels} requestsType={requestsType} />
        )}

        {activeView === 'profile' && isAuth && (
          <Profile user={user} onUpdate={setUser} />
        )}
      </div>
        {/* Модалка бронирования */}
        {selectedRequest && (
          <BookingForm
            request={selectedRequest}
            equipment={selectedEquipmentForBooking}
            onClose={() => {
              setSelectedRequest(null);
              setSelectedEquipmentForBooking(null);
            }}
            onSuccess={() => {
              setSelectedRequest(null);
              setSelectedEquipmentForBooking(null);
              fetchRequests(); // обновить список
            }}
            userTelegramId={user?.id}
          />
        )}
      {/* Модальное окно авторизации */}
      {showAuthModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <div style={{ position: 'relative', maxWidth: '500px', width: '90%' }}>
            <button
              onClick={() => setShowAuthModal(false)}
              style={{
                position: 'absolute',
                top: '-40px',
                right: '0',
                background: 'none',
                border: 'none',
                color: 'white',
                fontSize: '30px',
                cursor: 'pointer'
              }}
            >
              ×
            </button>
            <LoginForm onLogin={handleLogin} />
          </div>
        </div>
      )}
      {/* Футер с офертой */}
<footer style={{
  marginTop: '40px',
  padding: '20px',
  textAlign: 'center',
  borderTop: '1px solid #e2e8f0',
  backgroundColor: '#f8fafc'
}}>
  <p style={{ fontSize: '14px', color: '#64748b' }}>
    Используя сайт, вы соглашаетесь с{' '}
    <a href="/offer" target="_blank" style={{ color: '#667eea', textDecoration: 'none' }}>
      публичной офертой
    </a>
  </p>
  <p style={{ fontSize: '14px', color: '#64748b', marginTop: '10px' }}>
    📧 По вопросам:{' '}
    <a
      href="mailto:help@t161.ru"
      style={{ color: '#667eea', textDecoration: 'none', fontWeight: '500' }}
    >
      help@t161.ru
    </a>
  </p>
  <p style={{ fontSize: '12px', color: '#94a3b8', marginTop: '8px' }}>
    © 2026 t161.ru — Аренда спецтехники в Ростовской области
  </p>
</footer>
    </div>
  );
}

export default App;